<bw-header-label-cell-legacy
  @fadeIn
  *ngIf="accountCellConfig"
  (clickEvent)="routeToSavings()"
  [labelCellConfig]="accountCellConfig"
  [hasContent]="savingsState === 'PENDING'"
>
  <bw-bui-tile-legacy
    *ngIf="savingsState === 'PENDING'"
    tileMargin="0 0 8px 0">
    <bui-tile-card-legacy [cardBackground]="'var(--green-5)'">
      <bw-bui-row-legacy [rightIconName]="'hour-glass'" rightIconColor="var(--green-60)">
        <div class="row-content">
          <bw-bui-column-legacy
            [rowSpacing]="4"
            [rows]="[
                  { type: 'heading', content: 'ACCOUNT_PENDING_TITLE' | translate, color: 'var(--primary-text)' },
                  { type: 'paragraph', content: 'ACCOUNT_PENDING_DESC' | translate, color: 'var(--secondary-text)' }
                ]"
          ></bw-bui-column-legacy>
        </div>
      </bw-bui-row-legacy>
    </bui-tile-card-legacy>
  </bw-bui-tile-legacy>
</bw-header-label-cell-legacy>
